import { SvgIcon, SvgIconProps } from '@mui/material';

export const DownloadIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} fill="none" viewBox="0 0 20 20" stroke="currentColor">
    <path d="M3.33398 13.3346L3.33398 14.168C3.33398 15.5487 4.45327 16.668 5.83398 16.668L14.1673 16.668C15.548 16.668 16.6673 15.5487 16.6673 14.168L16.6673 13.3346M13.334 10.0013L10.0007 13.3346M10.0007 13.3346L6.66732 10.0013M10.0007 13.3346L10.0006 3.33464" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"/>
  </SvgIcon>  
);
